import { render } from "./NotificationSystem.vue?vue&type=template&id=bc8bf5fa&scoped=true"
import script from "./NotificationSystem.vue?vue&type=script&lang=js"
export * from "./NotificationSystem.vue?vue&type=script&lang=js"

import "./NotificationSystem.vue?vue&type=style&index=0&id=bc8bf5fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8bf5fa"]])

export default __exports__